import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import PageSection from '../PageSections/PageSection';
import RichTextConverter from './RichText/RichTextConverter';
import * as styles from './StylizedHeadlineCallout.module.scss';

export default function StylizedHeadlineCallout({ section }) {
  let bgColor;
  switch (section.backgroundColor) {
    case 'evergreen deep': {
      bgColor = styles.evergreenDeep;
      break;
    }
    default: {
      bgColor = '';
      break;
    }
  }

  return (
    <PageSection
      slim
      className={[styles.stylizedHeadlineHeader, !section.useFloatingLayout ? bgColor : ''].join(' ')}
      innerClassName={[styles.columns, bgColor, section.useFloatingLayout ? styles.floating : ''].join(' ')}
      data-analytics-section={'stylized-headline-callout'}
    >
      <div>
        <ContentfulImage
          imageFragment={section.stylizedHeading}
          style={{ translate: `${section.headlineLeftOffset}%` }}
          lazy={true}
        />
        {section.copy && <RichTextConverter copy={section.copy} />}
      </div>
      {section.image && <ContentfulImage imageFragment={section.image} className={styles.image} lazy={true} />}
    </PageSection>
  );
}
